import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);
dayjs.extend(timezone);

const BUILD_AI_AGENTS_WEBINAR_TZ = 'America/Los_Angeles';

/**
 * Exclusive end: Thursday June 25, 2026, 9:00am America/Los_Angeles (live webinar start).
 * The Build AI Agents promo replaces the Marty Cagan replay card while now is strictly before this instant.
 */
export const BUILD_AI_AGENTS_WEBINAR_ATF_SLOT_END_ISO_LOCAL = '2026-06-25T09:00:00';

/** Riverside registration page (CONENG-2426). */
export const BUILD_AI_AGENTS_WEBINAR_REGISTRATION_HREF =
  'https://riverside.com/webinar/registration/eyJldmVudElkIjoiNmEyYjBmOTc2NWM3NmI4NDdkZTJiMzk1Iiwic2x1ZyI6InBhdHJpY2stZG9ub3ZhbnMtc3R1ZGlvLXhueEZ4In0=';

/**
 * Whether the Build AI Agents live-webinar ATF promo should replace slot 4 (Marty Cagan replay).
 * Active when now is strictly before the webinar start in America/Los_Angeles.
 */
export function isBuildAiAgentsWebinarAtfSlotActive(now: dayjs.Dayjs): boolean {
  const end = dayjs.tz(BUILD_AI_AGENTS_WEBINAR_ATF_SLOT_END_ISO_LOCAL, BUILD_AI_AGENTS_WEBINAR_TZ);

  return now.isBefore(end);
}
